import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import { selectHybridStoreMerchantById } from 'core/modules/HybridSearchResults/components/HybridStores/selectors';
import { triggerHybridStoresOfferOverlayIsViewed } from './actions';
import Modal from 'core/modules/Modal/Modal';
import HybridStoresOffer from './components/HybridStoresOffer';

function HybridStoresOfferModal({ modal }) {
  const dispatch = useDispatch();
  const { id } = modal.params;

  const merchant = useSelector((state) => selectHybridStoreMerchantById(state, id));

  useEffect(() => {
    if (merchant) {
      dispatch(triggerHybridStoresOfferOverlayIsViewed(merchant.name));
    }
  }, [merchant]);

  if (isEmpty(merchant)) return null;

  return (
    <Modal className="mn_hybridStoresOfferModal" options={{ shouldUpdateUrl: true }}>
      <HybridStoresOffer merchant={merchant} />
    </Modal>
  );
}

export default (props) => <ComponentErrorBoundary><HybridStoresOfferModal {...props} /></ComponentErrorBoundary>;
